<template>
<!-- 订单管理－购买订单记录－使用详情 -->
<!-- 会员管理－购买订单记录－使用详情 -->
    <content-view>
        <div class="wrap-container-in">
            <a-tabs :defaultActiveKey="0" size="small" :animated="false" :tabBarStyle="{height: '50px', borderBottom: '0px', padding: '0px 12px'}">
                <template slot="tabBarExtraContent">
                    <a-radio-group v-if="isGived" v-model="isOriginal" button-style="solid" @change="isOriginalChange">
                        <a-radio-button :value="0">
                            当前持有人
                        </a-radio-button>
                        <a-radio-button :value="1">
                            原持有人
                        </a-radio-button>
                    </a-radio-group>
                </template>
                <a-tab-pane tab="核销记录" :key="1" :forceRender="true">
                    <div>
                        <a-table style="word-break:break-all;" :scroll="{y:400}" bordered :pagination="pagination1" @change="changePage1" :dataSource="dataSource1" :columns="columnsVerify" :rowKey="(record,index) => index">
                            <span slot="platform" slot-scope="platform, row">{{!platform ? "-" : platform == "收银台" ? row.shopName : platform}}</span>
                            <span slot="isFlag" slot-scope="isFlag">{{['否','是'][Number(isFlag)]}}</span>
                            <span slot="orderNum" slot-scope="orderNum, row">{{row.reserveNo ? row.verifyNum : "-"}}</span>
                            <span slot="empty" slot-scope="empty">{{empty || "-"}}</span>
                            <span slot="action" slot-scope="text, row">
                                <span v-if="getBtnByAuth('verifyReservationRecord')">
                                    <a class="text-primary" v-if="row.reserveNo" @click="openModal(row, 3)">预约记录</a>
                                    <span v-else class="text-disabled">预约记录</span>
                                </span>
                                <a-divider v-if="getBtnByAuth('verifyReservationRecord') && getBtnByAuth('ticketVerifyReturn')"/>
                                <span v-if="getBtnByAuth('ticketVerifyReturn')">
                                    <a v-if="row.returnNum < row.verifyNum" class="text-primary" @click="openModal(row, 2)">次数退还</a>
                                    <span v-else class="text-disabled">次数退还</span>
                                </span>
                            </span>
                        </a-table>
                    </div>
                </a-tab-pane>
                <a-tab-pane tab="预约记录" :key="2" :forceRender="true">
                    <div>
                        <a-table bordered :dataSource="dataSource" :columns="columnsOrder" :pagination="pagination" @change="changePage" :rowKey="(record,index) => index">
                            <span slot="state" slot-scope="state,row">{{['','已预约','预约取消','已核销','预约过期','次数退还'+row.returnNum+'次'][state]}}</span>
                            <span slot="orderNum" slot-scope="orderNum">{{orderNum || 1}}</span>
                            <span slot="buyShopName" slot-scope="buyShopName">{{buyShopName || "-"}}</span>]
                            <span slot="reserveShopName" slot-scope="reserveShopName">{{reserveShopName || "-"}}</span>
                            <span slot="platform" slot-scope="platform, row">{{!platform ? "-" : platform == "收银台" ? row.shopName : platform}}</span>
                            <span slot="reserveDate" slot-scope="reserveDate, row">{{row.periodStartTime | dateSplit}} ~ {{row.periodEndTime | dateSplit}}</span>
                            <span slot="reservePeriod" slot-scope="key, row">{{row.periodStartTime.substring(11, 16)}}~{{row.periodEndTime.substring(11, 16)}}</span>
                            <span v-if="getBtnByAuth('ticketReservationCancel')" slot="action" slot-scope="text, row">
                                <a @click="openModal(row, 1)" v-if="row.state == 1 || row.state == 4" class="text-primary">预约取消</a>
                                <a v-else class="text-disabled">预约取消</a>
                            </span>
                        </a-table>
                    </div>
                </a-tab-pane>

            </a-tabs>
            <a-modal
            centered
            title="取消预约"
            :visible="visibleCancel"
            @cancel="closeModal"
            @ok="cancelReserve"
            :width="500">
                <a-form :form="cancelForm">
                    <remark :labelSpan="5" :wrapperSpan="18" operateCode="CancelReserve" ></remark>
                </a-form>
            </a-modal>
            <a-modal
            title="预约记录"
                :visible="visibleOrderRecord"
                width="1000px"
                @cancel="visibleOrderRecord = false"
                :footer="false">
                <a-table bordered :dataSource="orderList" :columns="columns" :pagination="false" :rowKey="(record, index) => index">
                    <span slot="index" slot-scope="a, row, index">{{index + 1 }}</span>
                    <span slot="orderNum" slot-scope="orderNum">1</span>
                    <span slot="empty" slot-scope="empty">{{empty || "-"}}</span>
                </a-table>
            </a-modal>
            <count-refund @closeModalCountRefund="closeModalCountRefund" @closeModal="closeModal" :id="currentRow.id" :visibleCountRefund="visibleReturn" :maxNum="currentRow.verifyNum - currentRow.returnNum" />
        </div>
    </content-view>
</template>

<script type="text/javascript">
    import countRefund from '@/components/modules/order/count-refund.component';
    const columnsOrder = [
        {
            title: "用户票券id",
            dataIndex: "reserveObject"
        },
        {
            title: "预约人",
            dataIndex: "phone",
            scopedSlots: { customRender: "empty" }
        },
        {
            title: "票券名称",
            dataIndex: "name"
        },
        {
            title: "购买途径",
            dataIndex: "platform",
            scopedSlots: { customRender: "platform" }
        },
        {
            title: "预约使用门店",
            dataIndex: "reserveShopName",
            scopedSlots: { customRender: "reserveShopName" }
        },
        {
            title: "预约状态",
            dataIndex: "state",
            scopedSlots: { customRender: "state" }
        },
        {
            title: "预约次数",
            dataIndex: "orderNum",
            scopedSlots: { customRender: "orderNum" }
        },
        {
            title: "预约使用日期",
            dataIndex: "reserveDate",
            scopedSlots: { customRender: "reserveDate" }
        },
        {
            title: "预约场次",
            dataIndex: "reservePeriod",
            scopedSlots: { customRender: "reservePeriod" }
        },
        {
            title: "预约下单时间",
            dataIndex: "reserveTime",
            scopedSlots: { customRender: "reserveTime" }
        },
        {
            title: "操作",
            key: "action",
            scopedSlots: { customRender: "action" }
        }
    ]
    const columnsVerify = [
        {
            title: "用户票券id",
            dataIndex: "verifyObject"
        },
        {
            title: "会员手机号",
            dataIndex: "phone",
            scopedSlots: { customRender: "empty" }
        },
        {
            title: "核销人",
            dataIndex: "useUserPhone",
            scopedSlots: { customRender: "empty" }
        },
        {
            title: "票券名称",
            dataIndex: "name"
        },
        {
            title: "购买途径",
            dataIndex: "platform",
            scopedSlots: { customRender: "platform" }
        },
        {
            title: "核销门店",
            dataIndex: "verifyShopName",
            scopedSlots: { customRender: "empty" }
        },
        {
            title: "核销票台",
            dataIndex: "verifyPlatformName",
            scopedSlots: { customRender: "empty" }
        },
        {
            title: "预约次数",
            dataIndex: "orderNum",
            scopedSlots: { customRender: "orderNum" }
        },
        {
            title: "核销次数",
            dataIndex: "verifyNum",
            scopedSlots: { customRender: "verifyNum" }
        },
        {
            title: "退还次数",
            dataIndex: "returnNum",
            scopedSlots: { customRender: "returnNum" }
        },
        {
            title: "是否强制核销",
            dataIndex: "isForce",
            scopedSlots: { customRender: "isFlag" }
        },
        {
            title: "是否购买门店核销",
            dataIndex: "isBuyShopVerify",
            scopedSlots: { customRender: "isFlag" }
        },
        {
            title: "是否适用门店核销",
            dataIndex: "isSuitShopVerify",
            scopedSlots: { customRender: "isFlag" }
        },
        {
            title: "核销时间",
            dataIndex: "verifyTime",
            scopedSlots: { customRender: "empty" }
        },
        {
            title: "操作人",
            dataIndex: "cashier",
            scopedSlots: { customRender: "empty" }
        },
        {
            title: "操作",
            key: "action",
            scopedSlots: { customRender: "action" }
        }
    ];
    const columns = [
        {
            title: "序号",
            dataIndex: "index",
            scopedSlots: { customRender: "index" }
        },
        {
            title: "预约使用时间",
            dataIndex: "reserveDate",
            scopedSlots: { customRender: "reserveDate" }
        },
        {
            title: "预约场次",
            dataIndex: "reservePeriod",
            scopedSlots: { customRender: "reservePeriod" }
        },
        {
            title: "预约门店",
            dataIndex: "reserveShopName",
            scopedSlots: { customRender: "empty" }
        },
        {
            title: "预约次数",
            dataIndex: "orderNum",
            scopedSlots: { customRender: "orderNum" }
        },
    ]
    import remark from '@/components/modules/platform/remark.component';
    export default {
        name: "usingDetail",
        components: {
            countRefund,
            remark
        },
        props: {},
        data() {
            return {
                visibleOrderRecord: false,
                visibleCancel: false,
                columnsOrder,
                columnsVerify,
                columns,
                dataSource: [],
                dataSource1: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                pagination1: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                visibleReturn: false,
                currentRow: {},
                orderList: [],
                isOriginal: 0,
                isGived: false
            };
        },
        filters: {
            dateSplit(val) {
                if (!val) return "";
                return val.substring(0, 10);
            }
        },
        methods: {
            // 获取基础票券详情
            getDetail() {
                this.$api.order
                    .detailUserTicket({
                        params: {userTicketNo: this.$route.query.userTicketId}
                    }).then(res => {
                    this.isGived = res.userTicketNo !== res.originalUserTicketNo;
                });
            },
            changePage(page) {
                this.pagination.pageSize = page.pageSize
                this.pagination.current = page.current
                this.getList()
            },
            changePage1(page) {
                this.pagination1.pageSize = page.pageSize
                this.pagination1.current = page.current
                this.getListVerify()
            },
            getOrderList() {
                if (!this.currentRow.reserveObject && !this.currentRow.verifyObject) return;
                let verifyNo = this.currentRow.id;
                this.loading = true;
                this.$api.order.getVerifyReserveList({
                    body: {
                        pageNum: 1,
                        pageSize: 9999,
                        verifyId: verifyNo,
                    }
                }).then(res => {
                    this.loading = false;
                    this.orderList = res.list;
                }).catch(err => {
                    this.loading = false;
                })
            },
            // 获取预约列表
            getList() {
                this.$api.order.getTicketOrderList({
                    query: {
                        pageNum: this.pagination.current,
                        pageSize: this.pagination.pageSize,
                        reserveObject: this.$route.query.userTicketId,
                        isOriginal: Boolean(this.isOriginal)
                    }
                }).then(res => {
                    this.pagination.total = res.total;
                    this.dataSource = res.list;
                }).catch(err => {
                })
            },
            getListVerify() {
                this.$api.order.getTicketVerifyList({
                    query: {
                        pageNum: this.pagination1.current,
                        pageSize: this.pagination1.pageSize,
                        verifyObject: this.$route.query.userTicketId,
                        isOriginal: Boolean(this.isOriginal)
                    },
                }).then(res => {
                    this.pagination1.total = res.total;
                    this.dataSource1 = res.list;

                }).catch(err => {
                })
            },
            // 取消预约
            cancelReserve() {
                this.cancelForm.validateFields((err, values) => {
                    if (err) return;
                    this.$api.order.cancelReserve({
                        body: {reserveId: this.currentRow.id, ...values}
                    })
                    .then(res => {
                        this.visibleCancel = false;
                        this.$message.success('操作成功',2)
                        setTimeout(() => {
                            this.getList();
                        }, 500);
                    })
                })

            },
            openModal(row, type) {
                this.currentRow = row
                if (type == 1) {
                    this.cancelForm.resetFields();
                    this.visibleCancel = true;
                } else if (type == 2) {
                    this.visibleReturn = true
                } else if (type == 3) {
                    this.visibleOrderRecord = true
                    this.getOrderList();
                }
            },
            closeModal() {
                this.visibleReturn = false;
                this.visibleCancel = false;
                setTimeout(() => {
                    this.getList();
                    this.getListVerify();
                }, 500);
            },
            closeModalCountRefund() {
                this.visibleReturn = false
            },
            /**
             * @isOriginalChange 是否当前持有人
             */
            isOriginalChange() {
                this.getList();
                this.getListVerify();
            },
        },
        created() {
            this.cancelForm = this.$form.createForm(this);
        },
        mounted() {
            this.getDetail();
            this.getList();
            this.getListVerify();
        }
    };
</script>
<style lang="scss">
</style>
